<section class="modal-cluster">
  <div class="items-container">
    <div class="item" *ngFor="let item of markers" (click)="seeDetails($event, item)">
      <div style="display: flex; flex-direction: column; width: 100%;">
        <div style="display: flex">
          <img imageError src="{{getImageUrlThumb(item.mainImage) ?? ''}}" />
          <div class="object-item-info">
            <div class="price-and-options">
          <span class="price">
            {{ item.price | currency:  item.priceCurrency:'symbol':'1.0-0' }}
          </span>
            </div>
            <div class="options-block">
              <p *ngIf="item.rooms" class="rooms">
                <span class="rooms-count" *ngIf="item.rooms" title="{{'property_similar.rooms' | translate}}"><b>{{ item.rooms }}</b></span>
              </p>
              <p *ngIf="item.bedroom" class="bedroom">
                <span class="bedrooms" *ngIf="item.bedroom" title="{{'property_similar.beds' | translate}}"><b>{{ item.bedroom }}</b></span>
              </p>
              <p *ngIf="item.bathroom" class="bathroom">
                <span class="bathrooms" *ngIf="item.bathroom" title="{{'property_similar.bath' | translate}}"><b>{{ item.bathroom }}</b></span>
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="item.fullAddress.length"
             class="markers-address text-ellipsis" [title]="item.fullAddress">{{ item.fullAddress }}
        </div>
      </div>
    </div>
  </div>
</section>
